export default __webpack_public_path__ + "static/media/tts_en_alph_a2(-6).7a024bf4.mp3";